import styled from 'styled-components';

export const ModalBody = styled.div`
  button {
    margin-left: auto;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 12px;
  gap: 8px;

  > h3 {
    width: 100%;
  }

  > div {
    width: 380px;
    max-width: 100%;
    .modal-input {
      width: 100%;
      min-height: 100%;
    }
  }
  > button {
    margin-left: 0;
  }

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
    align-items: start;

    > div {
      width: 100%;
    }
  }
`;
